import React, { useState } from 'react'

const TextareaField = ({
    label,
    id,
    name,
    value,
    onChange,
    disabled = false,
    prefix,
    error,
    required,
    rows,
    maxLength
  }) => {
    let errorMsg =error
    const [focus,setFocus] = useState(false) 
  return (
    <div className="UI-form-group" style={{ gridColumn: '1 / -1' }}>
      <label className="UI-label" style={{color:errorMsg && "red"}}>{label}{required && <sup className="tw-font-normal">*</sup>}</label>
      <textarea
        id={id}
        name={name}
        className="UI-textarea"
        value={value}
        onChange={onChange}
        maxLength={maxLength}
        rows={rows}
        onFocus={()=>setFocus(true)}
        onBlur={()=>setFocus(false)}
        style={{
            borderStyle:disabled && "dashed",
            backgroundColor: disabled && "#f3f4f6",
            borderColor:errorMsg ? "red":focus && "#3574de", 
        }}
    />
    <div className='tw-flex tw-justify-between'>
       <div>
       {errorMsg && <p className="tw-text-[10px] tw-text-[#ff0000] m-0 tw-pt-0.5 tw-pl-1">{errorMsg}</p>}
      </div>
      <div className="UI-helper-text text-right !tw-text-[10px]">
      {(value?.length || 0)}/{maxLength}
  </div>
  </div>
</div>
  )
}

export default TextareaField